import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'onefaceui-react-components';

import { FormSection, FormSectionColumn } from 'react/containers/layout/Crud';
import Loading from 'react/components/Loading';

function ActionsSection({ isGrid, loadingInitialValues }) {
  function showOnlyInForm() {
    const onClickAction = (e) => {
      e.preventDefault();

      Greenmile.Survey.Form.createNewAction();
    };

    if (!isGrid) {
      return (
        <FormSectionColumn>
          <div id='generateTaskSectionContainer' />

          {loadingInitialValues ? (
            <Loading width='30px' height='30px' theme='blue' />
          ) : (
            <Button
              id='addActionButton'
              className='addItem'
              onClick={onClickAction}
            >
              {Monet.I18n.getResourcesByKey('Survey.form.btn.addActionButton')}
            </Button>
          )}
        </FormSectionColumn>
      );
    }

    return <></>;
  }

  return (
    <FormSection
      className='actionsSection'
      title='Survey.form.generateTaskSection'
    >
      {showOnlyInForm()}
    </FormSection>
  );
}

ActionsSection.propTypes = {
  isGrid: PropTypes.bool.isRequired,
  loadingInitialValues: PropTypes.bool
};

export default ActionsSection;
